import { render, staticRenderFns } from "./ManualPoints.vue?vue&type=template&id=1c00c518&"
import script from "./ManualPoints.vue?vue&type=script&lang=js&"
export * from "./ManualPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports